import { Button } from "@components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { Label } from "@components/ui/label";
import { RadioGroup, RadioGroupItem } from "@components/ui/radio-group";
import { deleteInterview } from "@endpoints/interview.service";
import { useSnackbar } from "notistack";
import React, { SetStateAction, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

type DeleteInterviewDialogProps = {
  openDialog: boolean;
  setOpenDialog: React.Dispatch<SetStateAction<boolean>>;
  data: {
    interviewId: string;
    slotSelectionType: "general" | "specific";
  };
};

const DeleteInterviewDialog = (props: DeleteInterviewDialogProps) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { openDialog, setOpenDialog, data } = props;

  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteInterview = async () => {
    try {
      setIsDeleting(true);
      const { success } = await deleteInterview(data?.interviewId);
      if (success) {
        if (data?.slotSelectionType === "general") {
          navigate("/calendar/meeting/scheduling");
        } else {
          navigate("/calendar/meeting");
        }
        enqueueSnackbar("Interview deleted successfully.", {
          variant: "success",
        });
        setOpenDialog(false);
      }
    } catch (error) {
      enqueueSnackbar("Error deleting interview.", { variant: "error" });
      console.error("Error: deleting interview", error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={openDialog} onOpenChange={setOpenDialog}>
      <DialogContent className="bg-white w-[340px] max-w-[340px]">
        <DialogHeader>
          <DialogTitle className="text-sm leading-[1.2rem]">
            Are you sure want to delete the interview?
          </DialogTitle>
          <DialogDescription className="text-xs font-medium text-light-black">
            Please confirm before proceeding.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button
            onClick={handleDeleteInterview}
            type="submit"
            isLoading={isDeleting}
            className="text-white"
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteInterviewDialog;
